import React from 'react';
import PropTypes from 'prop-types';
import PropertyForm from '../../Property/Property/PropertyForm';

export default function CreatePropertyPage({
	accountId,
	create_property_endpoint,
	create_property_ownership_endpoint,
	create_power_of_attorney_endpoint,
	create_business_license_survey_endpoint,
	create_subscription_endpoint
}) {
	return (
		<div>
			<PropertyForm
				accountId={accountId}
				create_property_endpoint={create_property_endpoint}
				create_property_ownership_endpoint={create_property_ownership_endpoint}
				create_power_of_attorney_endpoint={create_power_of_attorney_endpoint}
				create_business_license_survey_endpoint={
					create_business_license_survey_endpoint
				}
				create_subscription_endpoint={create_subscription_endpoint}
			/>
		</div>
	);
}

CreatePropertyPage.propTypes = {
	accountId: PropTypes.number,
	create_property_endpoint: PropTypes.string.isRequired,
	create_property_ownership_endpoint: PropTypes.string.isRequired,
	create_power_of_attorney_endpoint: PropTypes.string.isRequired,
	create_business_license_survey_endpoint: PropTypes.string.isRequired,
	create_subscription_endpoint: PropTypes.string.isRequired
};
